// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".crown-large[data-v-c55e1cb4] {\n  height: 16px;\n  width: 54px;\n}\n.crown[data-v-c55e1cb4] {\n  height: 20px;\n}\n.progress[data-v-c55e1cb4] {\n  height: 10px;\n  margin-bottom: 2px;\n}\n.progress-bar[data-v-c55e1cb4] {\n  background-color: #e8b103;\n}\n.points[data-v-c55e1cb4] {\n  color: var(--blue-50, #03288e);\n  font-weight: 600;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
